import { AxiosResponse } from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

class Logon {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Valida o usuário e gerar o token de acesso para o mesmo
     * @param {string} CPF Informe o CPF do usuário
     * @param {string} Senha Informe a senha do usuário
     **/
    public async Get(CPF: string, Senha: string): Promise<AxiosResponse<{token: string, pessoa: Objeto.Pessoa, empresasComPermissaoDeAcesso: Array<Objeto.Empresa>}>> {
        return await Context.get<{Token: string, Pessoa: any}>(`/Logon/${CPF}/${Senha}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Cadastra um novo usuário
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {string} Pessoa Informe o código da pessoa (Id)
     * @param {string} Senha Informe a senha do usuário
     **/
    public async Post(Token: string, Pessoa: number, Senha: string): Promise<AxiosResponse<any>> {
        return await Context.post<any>(`/Logon/${Token}/${Pessoa}/${Senha}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Solicitar a alteração da senha atual
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {string} CPF Informe o CPF (somente números)
     **/
    public async NovaSenha(CPF: string): Promise<AxiosResponse<{ remetente: string, destinatario: string }>> {
        return await Context.post<{ remetente: string, destinatario: string }>(`/Logon/NovaSenha/${CPF}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  PUT Controller  */
    /* Sobre esta função *//**
     * Altera a senha atual do usuário
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {string} SenhaAtual Informe a senha atual do usuário
     * @param {string} NovaSenha Informe a nova senha do usuário
     **/
    public async Put(Token: string, SenhaAtual: string, NovaSenha: string): Promise<AxiosResponse<any>> {
        return await Context.put<any>(`/Logon/${Token}/${SenhaAtual}/${NovaSenha}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */
};

export default new Logon();